module.exports = __webpack_public_path__ + "img/bg-404.30a02950.png";